import { useTitle } from './Hooks'

interface Title {
  title: string
}

const Head: React.FC<Title> = ({ title }) => {
  useTitle(title)
  return null
}

export default Head
